<ng-container [ngTemplateOutlet]="data?.config?.label?.attributes['cellType'] ? this[data.config.label.attributes['cellType']] : text"></ng-container>
<ng-template #text>
	<span>{{ data.formattedValue }}</span>
</ng-template>
<ng-template #link>
	<a target="_blank" [href]="data.config.label.attributes['url']">{{ data.formattedValue }}</a>
</ng-template>
<ng-template #productLink>
	<div *ngIf="data.attribute['url']; else text">
		<a class="text-bold" target="_blank" [href]="data.attribute['url'] | productUrl: data.attribute['assetClass']">{{ data.formattedValue }}</a>
	</div>
</ng-template>
<ng-template #iSharesIdeas>
	<div *ngIf="!isEmpty(data.rawValue); else text">
		<div *ngFor="let item of data.rawValue | keyvalue">
			<a class="ishares-link text-bold" [href]="item.value.portfolioId || item.value.ticker | productUrl" target="_blank" [tooltip]="iSharesTooltip" [tooltip-hover]="true">
				{{ item.value.ticker }}
			</a>
			<ng-template #iSharesTooltip>
				<div *ngIf="item.key === 'benchmark'" dcrHTMLKey="ISHARES_IDEA_BEST_FIT_BENCHMARK">Benchmark iShares idea</div>
				<div *ngIf="item.key === 'factor'" dcrHTMLKey="ISHARES_IDEA_BEST_FIT_FACTOR">Factor iShares idea</div>
				<div *ngIf="item.key === 'esg'" dcrHTMLKey="ISHARES_IDEA_BEST_FIT_ESG">Sustainable iShares idea</div>
			</ng-template>
		</div>
	</div>
</ng-template>
<ng-template #netPerformanceType>
	<span>{{ data.formattedValue }}</span>
	<span>{{ getAdvisoryFeeText(data.attribute['advisoryFee']) }}</span>
</ng-template>
<ng-template #array>
	<div class="array-cell">
		<div class="array-item" *ngFor="let item of data.formattedValue | split: ','">
			{{ item }}
		</div>
	</div>
</ng-template>
